import { StyledGradientText } from "./styles";

type Props = {
    text: string;
};

const AnimatedGradientText = ({ text }: Props) => {
    return <StyledGradientText fontVariant="input2Bold">{text}</StyledGradientText>;
};

export default AnimatedGradientText;
